/* eslint-disable max-params */
import { PAGE_SOURCE } from "../constants/app-constants";
import { EXPERIMENT_TYPE } from "../constants/optimize-constants";
import { checkActiveExperimentVariants } from "../utils/helpers/get-ab-expirement-variant";
import useExtendedWarrantyCheck from "./use-extended-warranty-check";

export const useEwVariantConfig = (cdpEwExperiment, paymentSummaryData, ewDetails, source = null) => {
    const hasExtendedWarranty = useExtendedWarrantyCheck(paymentSummaryData);
    const { ewVariant: overrideVariant = "" } = ewDetails || {};
    let currentVariant = cdpEwExperiment;

    if (overrideVariant) {
        currentVariant = {
            data: overrideVariant
        };
    }

    const showEwVariantB = checkActiveExperimentVariants(currentVariant, [
        EXPERIMENT_TYPE.VARIANT_B,
        EXPERIMENT_TYPE.VARIANT_D
    ]);

    const showEwVariantC = checkActiveExperimentVariants(currentVariant, [
        EXPERIMENT_TYPE.VARIANT_C,
        EXPERIMENT_TYPE.VARIANT_E
    ]);

    const showEwVariantF = checkActiveExperimentVariants(currentVariant, [
        EXPERIMENT_TYPE.VARIANT_F,
        EXPERIMENT_TYPE.VARIANT_G
    ]);

    const showEwVariantA =
        source === PAGE_SOURCE.VIDEO_GALLERY ||
        hasExtendedWarranty ||
        (!showEwVariantB && !showEwVariantC && !showEwVariantF) ||
        typeof ewDetails === "undefined" ||
        Object.keys(ewDetails).length === 0;

    return {
        showEwVariantA,
        showEwVariantB,
        showEwVariantC,
        showEwVariantF
    };
};
